import { useMemo } from 'react';
import { useAssetPreview } from 'framework-asset-preview-lib/internal/shared/providers/AssetPreviewProvider';
export default function useReadOnly() {
  const {
    readOnly,
    previewType
  } = useAssetPreview();

  /**
   * Only use @readOnly value when it has a value (true | false).
   * Otherwise, default its value to true.
   */
  return useMemo(() => {
    if (previewType === 'card' || previewType === 'popover') {
      return true;
    }
    return readOnly === undefined ? true : readOnly;
  }, [previewType, readOnly]);
}